export default [
   {
      id: 1,
      name: 'Úvod',
      path: '/',
      _protected: false,
   },
   {
      id: 20,
      name: 'služby',
      path: '/sluzby',
      _protected: false,
   },
   {
      id: 2,
      name: 'cenník',
      path: '/cennik',
      _protected: false,
   },
   {
      id: 3,
      name: 'galéria',
      path: '/galeria',
      _protected: false,
   },
   {
      id: 4,
      name: 'kontakt',
      path: '/kontakt',
      _protected: false,
   },
   {
      id: 5,
      _class: 'nav-divider',
      _protected: false,
   },
   {
      id: 6,
      name: 'profil',
      path: '/profil',
      _protected: true,
   },
   {
      id: 7,
      name: 'rezervovať',
      path: '/rezervovat',
      _protected: true,
   },
   {
      id: 8,
      name: 'admin',
      path: '/adminPanel',
      _protected: true,
   },
   {
      id: 15,
      name: '',
      // path: '',
      _protected: false,
   },
];
